<p-tabs [value]="selectedTabIndex()">
  <p-tablist>
    <p-tab value="0">Something</p-tab>
    <p-tab value="1">Something else</p-tab>
    <p-tab value="2">Under construction</p-tab>
  </p-tablist>

  <p-tabpanels>
    <p-tabpanel value="0">
      <app-under-construction />
      <div class="flex flex-column gap-2 mt-3">
        <h2>Contract Sections Editors</h2>
        <p-button
          label="Quill Editor"
          icon="pi pi-file-edit"
          [routerLink]="contractSectionsRoute"
        >
        </p-button>
        <p-button
          label="TinyMCE Editor"
          icon="pi pi-file-edit"
          severity="success"
          [routerLink]="contractSectionsRoute"
        >
        </p-button>
        
        <p-divider></p-divider>
        
        <p-button
          label="Crea Nuovo Template"
          icon="pi pi-plus"
          severity="success"
          [routerLink]="contractTemplatesRoute"
        >
        </p-button>
      </div>
    </p-tabpanel>

    <p-tabpanel value="1">
      <app-under-construction />
    </p-tabpanel>

    <p-tabpanel value="2">
      <app-under-construction />
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
